function EmptyRow({ message = 'Nothing to show' }: { message? : string }) {
  return (
    <div className="p-4 italic font-light text-center col-span-full">
      <span>{message}</span>
    </div>
  )
}
export default EmptyRow;